import { Link, NavLink, Outlet } from "react-router-dom";
import { useState } from "react";
import {
  LayoutDashboard, CalendarDays, ListChecks, ClipboardList, Tags,
  Users, Wallet, Settings, ExternalLink, Menu, X,
} from "lucide-react";

const NAV = [
  { to: "/partner", label: "Ana Panel", icon: LayoutDashboard, end: true },
  { to: "/partner/takvim", label: "Takvim", icon: CalendarDays },
  { to: "/partner/seanslar", label: "Seanslar", icon: ListChecks },
  { to: "/partner/rezervasyonlar", label: "Rezervasyonlar", icon: ClipboardList },
  { to: "/partner/fiyatlandirma", label: "Fiyatlandırma", icon: Tags },
  { to: "/partner/musteriler", label: "Müşteriler", icon: Users },
  { to: "/partner/finans", label: "Finans", icon: Wallet },
  { to: "/partner/ayarlar", label: "Ayarlar", icon: Settings },
];

export default function PartnerLayout() {
  const [open, setOpen] = useState(false);

  const Sidebar = (
    <div className="flex h-full flex-col">
      <div className="flex items-center gap-2 px-6 py-6">
        <div className="flex h-8 w-8 items-center justify-center rounded-md bg-[#2D2926] text-sm font-bold text-white">X</div>
        <div>
          <p className="text-sm font-semibold leading-none text-[#0F172A]">XYZ Partner</p>
          <p className="mt-1 text-xs text-[#64748B]">Stüdyo Paneli</p>
        </div>
      </div>
      <nav className="flex-1 space-y-1 px-3">
        {NAV.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.end}
            onClick={() => setOpen(false)}
            data-testid={`partner-nav-${n.to.split("/").pop() || "dashboard"}`}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-md px-3 py-2.5 text-sm transition-colors ${
                isActive ? "bg-[#2D2926] text-white" : "text-[#475569] hover:bg-[#F1F5F9]"
              }`
            }
          >
            <n.icon className="h-4 w-4" /> {n.label}
          </NavLink>
        ))}
      </nav>
      <Link to="/" data-testid="partner-back-to-app" className="m-3 flex items-center gap-2 rounded-md border border-[#E2E8F0] px-3 py-2.5 text-sm text-[#475569] transition-colors hover:bg-[#F1F5F9]">
        <ExternalLink className="h-4 w-4" /> Kullanıcı uygulaması
      </Link>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#F7F9FA] font-ops text-[#0F172A]">
      <aside className="fixed inset-y-0 left-0 hidden w-64 border-r border-[#E2E8F0] bg-white lg:block">{Sidebar}</aside>

      {/* Mobile */}
      <div className="flex items-center justify-between border-b border-[#E2E8F0] bg-white px-4 py-3 lg:hidden">
        <div className="flex items-center gap-2"><div className="flex h-7 w-7 items-center justify-center rounded-md bg-[#2D2926] text-xs font-bold text-white">X</div><span className="text-sm font-semibold">XYZ Partner</span></div>
        <button data-testid="partner-menu-toggle" onClick={() => setOpen(!open)}>{open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}</button>
      </div>
      {open && <div className="fixed inset-0 z-40 bg-black/30 lg:hidden" onClick={() => setOpen(false)}><aside className="absolute inset-y-0 left-0 w-64 bg-white" onClick={(e) => e.stopPropagation()}>{Sidebar}</aside></div>}

      <main className="lg:pl-64">
        <div className="mx-auto max-w-6xl px-5 py-6 lg:px-8 lg:py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
